// Appels HTTP typés vers /api/clients/*.

import { api } from "./client";
import type {
  ClientCreate,
  ClientPublic,
  ClientUpdate,
  UUID,
} from "./types";

export type ListClientsParams = {
  q?: string;
  limit?: number;
  offset?: number;
};

function buildQuery(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  }
  return parts.length ? `?${parts.join("&")}` : "";
}

export const clientsApi = {
  list: (params: ListClientsParams = {}) =>
    api.get<ClientPublic[]>(`/api/clients${buildQuery(params)}`),

  get: (id: UUID) => api.get<ClientPublic>(`/api/clients/${id}`),

  create: (payload: ClientCreate) =>
    api.post<ClientPublic>("/api/clients", payload),

  update: (id: UUID, payload: ClientUpdate) =>
    api.patch<ClientPublic>(`/api/clients/${id}`, payload),

  delete: (id: UUID) => api.delete<void>(`/api/clients/${id}`),
};
